
<script lang="ts" setup>
import {useI18n} from 'vue-i18n';
import useCpBem from '~/composables/useCpBem';
import CpText from '~/components/cp/CpText/CpText.vue';
import CpLink from '~/components/cp/CpLink/CpLink.vue';
import CpSectionHeader from '~/components/cp/CpSection/CpSectionHeader/CpSectionHeader.vue';
import CpFilterPill from '~/components/cp/CpFilterPill/CpFilterPill.vue';
import type {IAppliedFilterType} from '~/types';

const model = defineModel<IAppliedFilterType[]>();

const {b, e} = useCpBem('cp-dropdown-section-applied-filter');
const {t} = useI18n();

defineEmits<{
  (e: 'change-value', value: string): void
  (e: 'remove-all-filters'): void
  (e: 'remove-filter', filterType: string, appliedFilter: any): void
}>();

</script>
<template>
    <div :class="b">
        <CpSectionHeader :class="e`section-header`" :title="t('appliedFilters')" type="h1-fake" show-top-border />
        <div :class="e('remove-filters-container')">
            <CpLink :with-icon="false" full-width color="critical" @click="$emit('remove-all-filters')">
                {{ t('removeFilters') }}
            </CpLink>
        </div>
        <div :class="e('applied-filters-container')">
            <div v-for="filterType in model" :key="filterType.value" :class="e('applied-filter-container')">
                <CpText variant="subheading">
                    {{ filterType.label }}
                </CpText>
                <div :class="e('pills-container')">
                    <template v-for="appliedFilter in filterType.appliedFilters" :key="appliedFilter.value">
                        <CpFilterPill
                            :filter-tex="appliedFilter.label"
                            @click="$emit('remove-filter', filterType.value, appliedFilter.value)"
                        />
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss">
@import "assets/style/global";

.cp-dropdown-section-applied-filter {
  &__remove-filters-container {
    padding: $cp-gutter;
  }
  &__applied-filters-container {
    display: flex;
    flex-direction: column;
    gap: $cp-gutter;
    padding: $cp-gutter;
  }

  &__applied-filter-container {
    display: flex;
    flex-direction: column;
    gap: $cp-gutter-small;
  }

  &__pills-container {
    display: flex;
    flex-direction: row;
    gap: $cp-gutter-small;
    flex-wrap: wrap;
  }
}
</style>
<i18n locale="es-US" lang="yaml">
appliedFilters: 'Filtros aplicados'
removeFilters: 'Eliminar filtros'
</i18n>
